import { State } from '@api/ringil-api.v2';
import { resolveStateIcon } from '@utils/reservation.ts';

export interface CalendarStateStyle {
  wrapper: string;
  line: string;
  icon: JSX.Element | null;
}

/**
 * Card chrome derived from the reservation's workflow state: the border colour, the left stripe and
 * the state icon. Not a fragment — the colours are the card's frame, not a placeable attribute.
 *
 * The `border-*` / `bg-*` classes are composed at runtime, which works because the Tailwind config
 * safelists the `(text|border|bg)-(complementary|content)-*` patterns.
 */
export const resolveStateStyle = (state: State): CalendarStateStyle => {
  switch (state?.name) {
    case 'finished':
    case 'problem':
    case 'registration':
    case 'processing':
    case 'exit':
      return {
        wrapper: `border-${state.icon.color}`,
        line: `bg-${state.icon.color}`,
        icon: resolveStateIcon(state.icon),
      };
    default:
      return {
        wrapper: '',
        line: '',
        icon: null,
      };
  }
};
